// File: client/src/scenes/fines/FineTypeForm.jsx
import React, { useEffect, useMemo } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Stack,
  InputAdornment,
} from "@mui/material";

const EMPTY_FORM = {
  name: "",
  defaultAmount: "",
  description: "",
  paymentWindowDays: "",
};

const FineTypeForm = ({
  open,
  onClose,
  formData,
  setFormData,
  onSubmit,
  mode = "create",
  disabled = false,
}) => {
  useEffect(() => {
    if (!open) {
      setFormData(EMPTY_FORM);
    }
  }, [open, setFormData]);

  const isEditMode = mode === "edit";

  const paymentWindowDaysError = useMemo(() => {
    const raw = formData.paymentWindowDays;
    if (raw === "" || raw == null) return "";
    const numericValue = Number(raw);
    const isInteger = Number.isInteger(numericValue);

    if (!isInteger || numericValue <= 0) {
      return "Payment window must be a whole number greater than 0.";
    }

    return "";
  }, [formData.paymentWindowDays]);

  const canSubmit =
    formData.name?.trim().length > 0 && !paymentWindowDaysError && !disabled;

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>{isEditMode ? "Edit Fine Type" : "Create Fine Type"}</DialogTitle>
      <DialogContent>
        <Stack spacing={2} mt={0.5}>
          <TextField
            label="Name"
            value={formData.name}
            onChange={(e) => setFormData({ ...formData, name: e.target.value })}
            autoFocus
            required
            disabled={disabled}
            helperText="e.g., Late Contribution, Absenteeism"
          />
          <TextField
            label="Default Amount (optional)"
            value={formData.defaultAmount}
            onChange={(e) =>
              setFormData({ ...formData, defaultAmount: e.target.value })
            }
            type="number"
            inputProps={{ min: 0, step: "0.01" }}
            disabled={disabled}
            InputProps={{
              startAdornment: <InputAdornment position="start">KES</InputAdornment>,
            }}
          />
          <TextField
            label="Payment due within (days)"
            value={formData.paymentWindowDays}
            onChange={(e) =>
              setFormData({ ...formData, paymentWindowDays: e.target.value })
            }
            type="number"
            inputProps={{ min: 1, step: 1 }}
            disabled={disabled}
            error={!!paymentWindowDaysError}
            helperText={paymentWindowDaysError || "Optional. Whole number of days allowed for payment."}
          />
          <TextField
            label="Description (optional)"
            value={formData.description}
            onChange={(e) =>
              setFormData({ ...formData, description: e.target.value })
            }
            multiline
            rows={3}
            disabled={disabled}
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" onClick={onSubmit} disabled={!canSubmit}>
          {isEditMode ? "Update" : "Create"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default FineTypeForm;
